import { getDiffBetweenDates } from "@/helpers";

class Service {
  constructor(service) {
    this.id = service.id;
    this.payedTo = service.payedTo;
    this.title = service.title;
    this.type = service.type;
  }
  get color() {
    const duration = getDiffBetweenDates(this.payedTo, new Date(), "days");
    if (duration < 0 && duration > -6) {
      return "orange";
    }
    if (duration < 0) {
      return "green";
    }
    return "red";
  }
}

export {
  Service,
};